import { render, staticRenderFns } from "./VenueRecommendedMap.vue?vue&type=template&id=496af590&"
import script from "./VenueRecommendedMap.vue?vue&type=script&lang=js&"
export * from "./VenueRecommendedMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports